import { Icon } from "./Style";
import { style } from "./StyleType";

interface TmpIconCustomProps {
    id?: string;
    size: "sm" | "md" | "lg" | "xg";
    icon: React.ReactElement;
    className?: string;
    onClick?: () => void;
}

export default function TmpIconCustom(props: TmpIconCustomProps) {
    
    // Passing style props to styled component
    Icon.defaultProps = style;

    return (
        <Icon id={props.id} className={`tmp-icon ${props.className}`} size={props.size} onClick={props.onClick} >
            {props.icon}
        </Icon>
    );

}